import { Navigate, useLocation } from "react-router-dom";
import { LoadingSpinner } from "./ui/loading-spinner";
import { useAuth } from "@/context/AuthContext";

interface ProtectedRouteProps {
  children: JSX.Element;
  allowedRoles?: string[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const userType = localStorage.getItem("userDetails")
    ? JSON.parse(localStorage.getItem("userDetails")!).userType
    : null;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner size="large" color="rgb(5 83 156)" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userType)) {
    return <Navigate to="/alerts" replace />;
  }

  return children;
};

export default ProtectedRoute;
